/** 兌換選品頁 ↔ 說明頁 的草稿保存與還原。 */

/** 進說明頁前把草稿寫回選品頁的 entry。不可寫進 sourceCart，「本次不兌換」的取消清單靠它。 */
export const buildGuideHandoffState = (routeState = {}, draftCart = {}, scrollTop) => ({
    ...routeState,
    draftCart: { ...draftCart },
    ...(typeof scrollTop === 'number' ? { scrollTop } : {}),
});

/** 初始化草稿取哪一份。用 hasOwnProperty 判斷，空物件代表刻意減到 0，仍要採用。 */
export const resolveProductSelectDraft = (routeState) => {
    if (!routeState) return {};
    if (Object.prototype.hasOwnProperty.call(routeState, 'draftCart')) {
        return routeState.draftCart || {};
    }
    return routeState.sourceCart || {};
};
